import { useConsultDoctorContext } from "../../Contexts/ConsultDoctorContext";
import warningGeneral from "../../assets/warningGeneral.png";
import Button from "../../Components/Button";

export default function SaveFailedModal() {
  const { navigate, setSelectedDate, resetStates } = useConsultDoctorContext();

  const handleBack = () => {
    setSelectedDate();
    navigate("/home");
    resetStates();
  };

  return (
    <div
      style={{ top: 0, left: 0, bottom: 0, right: 0 }}
      className="min-h-screen max-w-screen flex fixed bg-black bg-opacity-20 backdrop-blur-sm z-50"
    >
      <div className="sm:w-96 w-89.5 bg-white m-auto rounded-2xl p-6 flex flex-col items-center">
        <img src={warningGeneral} alt="Personal" className="w-14 my-4" />
        <p className="text-xl font-bold mb-3 text-center">Saving failed!</p>
        <p className="text-center">
          Looks like your preferred doctor is already saved.
        </p>
        <Button className="w-full h-14 text-white mt-3" onClick={handleBack}>
          Back to dashboard
        </Button>
      </div>
    </div>
  );
}
